export default {
  // Hero section
  'hero.title': 'Professionelle Online-Timer-Tools',
  'hero.subtitle': 'Wählen Sie das perfekte Timing-Tool für Ihre Bedürfnisse',

  // Tool cards
  'timer.title': 'Timer',
  'timer.description': 'Countdown-Timer für Arbeit, Studium und Leben',
  'timer.longDescription': 'Countdown-Timer für Produktivität, Kochen und Zeitmanagement',
  'timer.button': 'Timer Starten',

  'stopwatch.title': 'Stoppuhr',
  'stopwatch.description': 'Hochpräzises Timing-Tool',
  'stopwatch.longDescription': 'Hochpräzise Stoppuhr für Sport, Training und präzise Zeitmessung',
  'stopwatch.button': 'Stoppuhr Starten',

  'worldclock.title': 'Weltuhr',
  'worldclock.description': 'Zeitzonen auf der ganzen Welt anzeigen',
  'worldclock.longDescription': 'Echtzeit-Anzeige der Uhrzeiten wichtiger Städte weltweit mit intelligenten Zeitzonenberechnungen',
  'worldclock.button': 'Weltuhr Anzeigen',

  // Features section
  'features.title': 'Warum timer.today Wählen?',
  'features.reliable.title': 'Zuverlässig und Genau',
  'features.reliable.desc': 'Millisekundengenaue Zeitmessung mit browserbasierer Zuverlässigkeit',
  'features.crossPlatform.title': 'Plattformübergreifend',
  'features.crossPlatform.desc': 'Funktioniert nahtlos auf Desktop, Tablet und mobilen Geräten',
  'features.smartNotifications.title': 'Intelligente Benachrichtigungen',
  'features.smartNotifications.desc': 'Tonalarme und Desktop-Benachrichtigungen wenn die Zeit abgelaufen ist',
  'features.easyToUse.title': 'Einfach zu Bedienen',
  'features.easyToUse.desc': 'Saubere Oberfläche mit intuitiven Bedienelementen für alle Benutzer',

  // Keywords section
  'keywords.timer': 'Timer Countdown Pomodoro Konzentration Arbeit Pause',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
